// @flow

import React from 'react'

type PropTypes = {
  display: boolean,
  requestUrl: string,
}

export default (props: PropTypes) => (
  <div
    className={`bottom__request-area pc-hide__sm-show ${
      props.display ? 'bottom__fixed' : ''
    }`}
    onClick={() => {
      window.location.href = props.requestUrl
    }}
  >
    <a href={props.requestUrl} className="btn__large btn__style bg_blue">
      {i18n.t('page.room.requestReservation1')}
      <br />
      {i18n.t('page.room.requestReservation2')}
    </a>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/molecules/room/BottomRequest/index.jsx